import { DOWNLOAD_DMS_S3_DOCUMENT } from 'src/constants/ApiConstants';
import { FileAttachmentsConstants } from 'src/constants/ProjectConstants';
import { GetApiBaseUrl } from 'src/constants/UrlConstants';
import { logger } from 'src/logger';
import { fetchWithRetryAndCaptureMetrics } from 'src/utilities/ApiHelper';
import { downloadAttachment } from 'src/utilities/Download';

interface IDownloadURL {
  documentName: string;
  documentId: string;
  showSpinner?: (status: boolean) => void;
  showError?: (status: boolean) => void;
}
export function downloadFile({
  documentName,
  documentId,
  showSpinner = () => {},
  showError = () => {},
}: IDownloadURL) {
  showSpinner(true);
  fetchWithRetryAndCaptureMetrics(
    DOWNLOAD_DMS_S3_DOCUMENT.metricsPublisher,
    `${GetApiBaseUrl()}${DOWNLOAD_DMS_S3_DOCUMENT.getRoute(documentId)}`,
    {
      method: DOWNLOAD_DMS_S3_DOCUMENT.method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    },
  )
    .then((response) => {
      const url = response.body?.s3Url;
      if (response.status.startsWith('2') && url) {
        downloadAttachment({ url, documentName });
      } else {
        return Promise.reject(FileAttachmentsConstants.ERROR_EMPTY_S3_URL);
      }
    })
    .catch((error) => {
      logger.error(
        `Downalod of document: ${documentId} is failed.  ${JSON.stringify(
          error,
        )}`,
      );
      showError(true);
    })
    .finally(() => {
      showSpinner(false);
    });
}
